import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { IconComponent } from '@shared/components/icon/icon.component';

import { TrialInsightsClinicalSiteCostChartService } from './site-cost-chart.service';
import { TrialInsightsClinicalSiteCostQueryService } from './site-cost-query.service';
import { TrialInsightsClinicalSiteCostStoreService } from './site-cost-store.service';
import { TrialInsightsClinicalSiteCostTableService } from './site-cost-table.service';
import { GenericTrialInsightsComponent } from '../../classes/trial-insights-component.class';
import { TrialInsightsHeaderComponent } from '../trial-insights-header/trial-insights-header.component';
import { TrialInsightsLegendComponent } from '../trial-insights-legend/trial-insights-legend.component';
import { TrialInsightsTableComponent } from '../trial-insights-table/trial-insights-table.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TrialInsightsHeaderComponent,
    IconComponent,
    NgStyle,
    TrialInsightsLegendComponent,
    TrialInsightsTableComponent,
  ],
  providers: [TrialInsightsClinicalSiteCostQueryService],
  selector: 'aux-trial-insights-clinical-site-cost',
  styleUrls: ['../../trial-insights.component.scss'],
  templateUrl: './site-cost.component.html',
})
export class TrialInsightsClinicalSiteCostComponent extends GenericTrialInsightsComponent {
  storeService = inject(TrialInsightsClinicalSiteCostStoreService);

  cdr: ChangeDetectorRef;
  chartService: TrialInsightsClinicalSiteCostChartService;
  queryService: TrialInsightsClinicalSiteCostQueryService;
  tableService: TrialInsightsClinicalSiteCostTableService;

  constructor() {
    const chartService = inject(TrialInsightsClinicalSiteCostChartService);
    const tableService = inject(TrialInsightsClinicalSiteCostTableService);
    const queryService = inject(TrialInsightsClinicalSiteCostQueryService);
    const cdr = inject(ChangeDetectorRef);

    super({
      cdr,
      chartService,
      color: '#084673',
      queryService,
      tableService,
      title: 'Sites',
    });

    this.chartService = chartService;
    this.tableService = tableService;
    this.queryService = queryService;
    this.cdr = cdr;
  }

  subscribeToData = () => {
    this.queryService
      .processSiteCostSummary$()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
    this.storeService.getSiteCostSummary$().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  };
}
